import { useEffect, useMemo, useState } from "react";
import { getDeclineReasonText } from "./CreditApplicationDetails/CreditApplicationDetailsCmps/helper";

// custom markup
import TableNew, { CELL_TYPES } from "../../../shared/Table";
import { TableCellAccountRedirect } from "../../../shared/Table/components/Cell";
import RefreshButton from "../../../shared/ui/Refresh.Button";

import CreditApplicationsTableButtons from "./CreditApplicationTableCells/CreditApplicationsTableButtons";
import { applicationConnector } from "../../../services/applications/connector";
import { compose } from "redux";

// formatters and other
import _ from "underscore";

// icons
import ClaimsWrapper from "../../../shared/ui/Claim.Wrapper";
import { allClaimsOtherThanAml } from "../../../shared/ClaimLists/Claim.Aml.All.List";
import CreditApplicationDetails from "./CreditApplicationDetails/Credit.Application.Details.Component";
import TableCellCreditApplicationActions from "../../../services/applications/tables/TableCellCreditApplicationActions";
import TableCellReviewCreditApplicationActions from "../../../services/applications/tables/TableCellReviewCreditApplicationActions";
import { TextField } from "@material-ui/core";
import MenuItem from "@material-ui/core/MenuItem";

const CreditApplicationsComponent = (props) => {
  const columns = getColumns();
  const filterTypes = [
    { value: "AmlVerified", label: "Aml passed", id: 0 },
    { value: "UnderAmlVerification", label: "Aml queued", id: 1 },
    { value: "All", label: "All", id: 2 },
  ];

  const [filterType, setFilterType] = useState("All");

  const sortedData = useMemo(() => {
    let dataSorted = _.sortBy(props.creditApplications.data, (application) => {
      return new Date(application.UserInfoFinalizedAt).valueOf();
    }).reverse();
    return dataSorted.sort((a, b) => {
      return Number(a.disabled) - Number(b.disabled);
    });
  }, [props.creditApplications.data]);

  const filteredSortedData = useMemo(() => {
    switch (filterType) {
      case "AmlVerified":
        return sortedData.filter((item) => !!item.disabled === false);
      case "UnderAmlVerification":
        return sortedData.filter((item) => !!item.disabled === true);
      default:
        return sortedData;
    }
  }, [sortedData, filterType]);

  useEffect(() => {
    if (props.creditApplications && !props.creditApplications.fetching)
      props.getCreditApplications();

    props.changeApplicationListPage(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const refreshFunction = props.getCreditApplications;
  const approveRejectFunction = props.approveRejectCreditOffers;

  return (
    <div className="applications-layout body-height content-padding">
      <RefreshButton onRefreshClick={refreshFunction} />

      <h3>Loanstep: Credit Applications</h3>
      {!props.creditApplications.fetched ? (
        <div> Loading... </div>
      ) : (
        <TableNew
          {...props}
          columns={columns}
          tableKey={"CreditApplications"}
          selectId={"Id"}
          items={filteredSortedData}
          showDetailsFun={addMoreInfo}
          actionColumnWidth={360}
          detailsRenderer={(item) => {
            return getDetails(item, props.accountInfos, approveRejectFunction);
          }}
          aboveContentRenderer={(getSelected, rows) => {
            return (
              <ClaimsWrapper claimAuth={allClaimsOtherThanAml}>
                <br />
                <CreditApplicationsTableButtons
                  getSelected={getSelected}
                  rows={rows}
                  {...props}
                />
                <TextField
                  size="small"
                  variant="outlined"
                  label="Aml Filter"
                  select
                  value={filterType}
                  onChange={(event) => setFilterType(event.target.value)}
                >
                  {filterTypes.map((type) => {
                    const menuItemStyle =
                      type.value === "All"
                        ? {
                            color: "#000000",
                            marginTop: "10px",
                            borderTop: "1px solid",
                          }
                        : { color: "#303030" };
                    return (
                      <MenuItem
                        style={menuItemStyle}
                        key={`filter-type-${type.id}`}
                        value={type.value}
                      >
                        {type.label}
                      </MenuItem>
                    );
                  })}
                </TextField>
              </ClaimsWrapper>
            );
          }}
        />
      )}
      <br />
    </div>
  );

  function addMoreInfo(row) {
    props.getRowAdditionalData(
      row.BorrowerId,
      row.Identity,
      row.BankAccountId,
      row.Id,
    );
  }

  function getDetails(item, accountInfos, approveRejectFunction) {
    return (
      <CreditApplicationDetails
        item={item}
        accountInfos={accountInfos}
        approveCreditOffer={props.approveCreditOffer}
        rejectCreditOffer={props.rejectCreditOffer}
        approveRejectCreditOffers={approveRejectFunction}
        rejectCreditApplication={props.rejectCreditApplication}
      />
    );
  }

  function getColumns() {
    return [
      {
        key: "BorrowerId",
        label: "Get ssn",
        visible: true,
        filter: false,
        type: CELL_TYPES.ssn,
      },
      {
        key: "UserInfoFinalizedAt",
        label: "UserInfo Finalized",
        visible: true,
        type: CELL_TYPES.date,
      },
      {
        key: "SubmittedAt",
        label: "Submitted",
        visible: true,
        type: CELL_TYPES.date,
      },
      {
        key: "EvaluatedAt",
        label: "Evaluated",
        visible: true,
        type: CELL_TYPES.date,
      },
      {
        key: "ExpiredAt",
        label: "Expired",
        visible: true,
        type: CELL_TYPES.date,
      },
      {
        key: "BorrowerId",
        label: "Borrower Id",
        visible: false,
        type: CELL_TYPES.text,
        renderer: (value) => {
          return <TableCellAccountRedirect value={value} type={"BorrowerId"} />;
        },
      },
      {
        key: "DeclineReason",
        label: "Decline Reason",
        visible: true,
        type: CELL_TYPES.text,
        renderer: (value) => {
          return <span>{getDeclineReasonText(value)}</span>;
        },
      },
      {
        key: "Id",
        label: "Actions",
        visible: true,
        filter: false,
        renderer: (value, item, props) => {
          return item.OnHold ? (
            <TableCellReviewCreditApplicationActions
              removeFromOnHold={props.removeFromOnHold}
              value={value}
              item={item}
              getAccountInfoForId={props.getAccountInfoForId}
              accountInfos={props.accountInfos}
            />
          ) : (
            <ClaimsWrapper claimAuth={allClaimsOtherThanAml}>
              <TableCellCreditApplicationActions
                putOnHold={props.putOnHold}
                expire={props.expire}
                item={item}
              />
            </ClaimsWrapper>
          );
        },
      },
    ];
  }
};

export const CreditApplication = compose(applicationConnector)(
  CreditApplicationsComponent,
);
